import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCurrency, unFormatPercentage } from '@/common/utils/unFormatters'
import { CreateSpecialEntryValidationSchema } from '@/features/privateCompanies/schemas/createSpecialEntry.schema'
import { useMutation } from '@tanstack/react-query'

type CreateCompanySpecialEntryProps = {
  companyId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useCreateCompanySpecialEntry = ({ companyId, onSuccess, onError }: CreateCompanySpecialEntryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createCompanySpecialEntry', companyId],
    mutationFn: async (form: CreateSpecialEntryValidationSchema) => {
      const unFormatFunction = form.calculate_as === 'percentage' ? unFormatPercentage : unFormatCurrency

      const fee_rule_attributes = {
        special_entries_attributes: [
          {
            fee_template_id: form.fee_template_id.value,
            target_id: form.target_id.value === 'all' ? null : form.target_id.value,
            target_type: 'Establishment::Company',
            value: unFormatFunction(form.value),
          },
        ],
      }

      return privateAxios.put(`/client/companies/${companyId}/fee_rule`, {
        fee_rule_attributes,
      })
    },
    onSuccess,
    onError,
  })
}
